import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDevAuth } from '../utils/useDevAuth';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

/**
 * Admin Social Summaries - Placeholder page for aggregated social media summaries
 */
const AdminSocialSummaries: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useDevAuth();

  // Check if user is admin
  const provider = user?.sub?.split('|')[0];
  const emailLower = user?.email?.toLowerCase() || '';
  const isAdmin = (provider === 'google-oauth2' || provider === 'clerk') && (emailLower === 'weezilla@gmail.com' || emailLower.endsWith('@crant.ai'));

  if (!isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h4">Unauthorized</Typography>
        <Typography>You do not have access to this page.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Button 
        variant="text" 
        onClick={() => navigate('/admin')}
        sx={{ mb: 2 }}
      >
        ← Back to Admin Dashboard
      </Button>
      
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Social Media Summaries
      </Typography>

      <Paper 
        sx={{ 
          p: 6, 
          textAlign: 'center',
          bgcolor: '#f5f5f5',
          border: '2px dashed #ccc',
        }}
      >
        <TrendingUpIcon sx={{ fontSize: 80, color: '#c62828', mb: 2 }} />
        <Typography variant="h5" sx={{ mb: 2, color: 'text.secondary' }}>
          Social Summaries Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, margin: '0 auto' }}>
          This page will show aggregated social media performance across all organizations,
          trending content, platform comparisons, and engagement benchmarks.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AdminSocialSummaries;

